import { simplePath } from "../utils.js";
const NAVIGATION_QUERY_KEY_FIRST_ITEM = 'navigation-breadcrumbs';
const GET_ORG_NAVIGATION_ITEMS = 'v2/user-navigation/org-items';
const GET_PROJ_NAVIGATION_ITEMS = 'v2/user-navigation/:organization/proj-items';
const GET_APP_NAVIGATION_ITEMS = 'v2/user-navigation/:organization/:project/app-items';
const get_org_navigation_items = ()=>simplePath(GET_ORG_NAVIGATION_ITEMS, {});
const get_proj_navigation_items = (params)=>simplePath(GET_PROJ_NAVIGATION_ITEMS, params);
const get_app_navigation_items = (params)=>simplePath(GET_APP_NAVIGATION_ITEMS, params);
const POST_PIN_NAVIGATION_ITEM = 'v2/user-navigation/pin';
const POST_UNPIN_NAVIGATION_ITEM = 'v2/user-navigation/unpin';
const post_pin_navigation_item = ()=>simplePath(POST_PIN_NAVIGATION_ITEM, {});
const post_unpin_navigation_item = ()=>simplePath(POST_UNPIN_NAVIGATION_ITEM, {});
export { GET_APP_NAVIGATION_ITEMS, GET_ORG_NAVIGATION_ITEMS, GET_PROJ_NAVIGATION_ITEMS, NAVIGATION_QUERY_KEY_FIRST_ITEM, POST_PIN_NAVIGATION_ITEM, POST_UNPIN_NAVIGATION_ITEM, get_app_navigation_items, get_org_navigation_items, get_proj_navigation_items, post_pin_navigation_item, post_unpin_navigation_item };
